import { render, staticRenderFns } from "./DepartList.vue?vue&type=template&id=331e09f0&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./DepartList.vue?vue&type=script&lang=js"
export * from "./DepartList.vue?vue&type=script&lang=js"
import style0 from "./DepartList.vue?vue&type=style&index=0&id=331e09f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e09f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331e09f0')) {
      api.createRecord('331e09f0', component.options)
    } else {
      api.reload('331e09f0', component.options)
    }
    module.hot.accept("./DepartList.vue?vue&type=template&id=331e09f0&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml", function () {
      api.rerender('331e09f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DepartList.vue"
export default component.exports